/* eslint-disable camelcase */
import $ from "jquery";
import debounce from "utils/debounce";
import i18n from "utils/i18n";

export const defaultAlertOptions = { align: "center", allow_dismiss: true, type: "danger" };
export const defaultNoticeOptions = { align: "center", allow_dismiss: true, type: "success" };

/**
 * Creates a Bootstrap growl alert message with our default options.
 *
 * @param {string} message The alert message
 * @param {object} options Additional options or options to override the defaults
 */
function alert(message, options = {}) {
  $.bootstrapGrowl(message, $.extend({}, defaultAlertOptions, options));
}

/**
 * Creates a Bootstrap growl alert message with our global error message.
 *
 * @param {Array} args The args needed to debounce error messages
 */
function error(...args) {
  if (debounce(error, args, 500)) {
    return;
  }

  alert(i18n.t("global.error"));
}

/**
 * Creates a Bootstrap growl notice message with our default options.
 *
 * @param {string} message The notice message
 * @param {object} options Additional options or options to override the defaults
 */
function notice(message, options = {}) {
  $.bootstrapGrowl(message, $.extend({}, defaultNoticeOptions, options));
}

/**
 * Creates a Bootstrap growl alert session expired message.
 */
function sessionExpired() {
  alert(i18n.t("global.error_csrf_html"), {
    align: "center",
    allow_dismiss: false,
    delay: 0,
    type: "danger"
  });
}

export default { alert, error, notice, sessionExpired };
